import * as Sentry from '@sentry/react'
import config from './config/config'

export function setupSentry() {
  console.log('[Sentry] Configuring for ' + config.NODE_ENV)

  if (!config.sentryDSN) {
    console.log('[Sentry] No DSN configured. Skipping.')
    return
  }

  Sentry.init({
    dsn: config.sentryDSN,
    environment: config.NODE_ENV,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    release: config.version,
    tracesSampleRate: config.sentrySampleRate,
  })
  console.log('[Sentry] Configured for ' + config.NODE_ENV)
}

export function identifySentryUser(user) {
  if (!user) return

  Sentry.setUser({ email: user.email })
}



// WEBPACK FOOTER //
// ./src/sentry.js